"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconCheckboxChain = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M51.17 45.49a9.47 9.47 0 0 1 3.4 2.09 4.3 4.3 0 0 1 .34-.69V28.47l-3.74 3.73zM38.7 53.34a.75.75 0 0 0-.55.23.74.74 0 0 0-.22.55.86.86 0 0 0 .85.85h2.11a4.32 4.32 0 0 1 1.65.33v-.32a4.3 4.3 0 0 1 .31-1.62zM29.42 52.46H18.75a.5.5 0 0 1-.5-.5V20a.5.5 0 0 1 .5-.5H48l3.63-3.63a4.22 4.22 0 0 0-.93-.11H18.75A4.24 4.24 0 0 0 14.51 20v32a4.25 4.25 0 0 0 4.24 4.24h10.76a9.19 9.19 0 0 1-.09-3.74z"
  }), _react["default"].createElement("path", {
    d: "M63.24 14.84a1.87 1.87 0 1 0-2.64-2.64L34.89 37.91 26.94 30a1.87 1.87 0 0 0-2.64 2.64L34.89 43.2zM40.88 57.46h-2.11a3.35 3.35 0 0 1-3.33-3.33 3.26 3.26 0 0 1 3.27-3.28h7.77c1.61 0 4.31.35 4.32 2.55a1.84 1.84 0 0 0 1.83 1.83 1.84 1.84 0 0 0 1.83-1.84c0-3.75-3.15-6.19-8-6.21h-7.77a6.93 6.93 0 0 0-6.93 7 7 7 0 0 0 7 7h2.12a1.83 1.83 0 0 0 0-3.67z"
  }), _react["default"].createElement("path", {
    d: "M61.26 47.26h-2.64a1.83 1.83 0 0 0 0 3.67h2.63c1.94 0 2.81 1.68 2.81 3.33a3.26 3.26 0 0 1-3.26 3.28h-8.29c-3.79 0-3.8-1.79-3.8-2.55a1.84 1.84 0 0 0-1.84-1.83A1.84 1.84 0 0 0 45 55a5.79 5.79 0 0 0 1.62 4.21 8.08 8.08 0 0 0 5.84 2h8.29a6.92 6.92 0 0 0 6.93-7c.04-4-2.68-6.93-6.42-6.95z"
  })),
  height: undefined,
  width: undefined
});
IconCheckboxChain.displayName = 'IconCheckboxChain';
var _default = IconCheckboxChain;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/checkbox-chain.js
// module id = 561
// module chunks = 0